import request from '@service/request';
import config from '@config';

export const fetchFifaRanking = () => request.get(`${config.apiURL}/fifa-ranking`);
